function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Carousel = void 0;
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native-web");
var _Heading = require("../Heading");
var _Button = require("../Button");
var _Pagination = require("../Pagination");
var _reactI18next = require("react-i18next");
var _useLang = require("./useLang");
var _styles = require("./styles");
var _utils = require("../../utils");
var _styles2 = require("../../styles");
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["children", "index", "style", "childrenCount"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var ImageContainer = function ImageContainer(_ref) {
  var children = _ref.children,
    styles = _ref.styles,
    spacerWidth = _ref.spacerWidth,
    offsetX = _ref.offsetX;
  var _STYLES$useStyles = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles.bp;
  if (bp.desktop) {
    return (0, _jsxRuntime.jsx)(_reactNative.Animated.View, {
      style: [styles.imageContainer, {
        width: spacerWidth,
        opacity: offsetX.interpolate({
          inputRange: [0, 100],
          outputRange: [1, 0],
          extrapolate: 'clamp'
        })
      }],
      children: children
    });
  }
  return (0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: children
  });
};
var SlideChild = (0, _react.memo)(function (_ref2) {
  var children = _ref2.children,
    index = _ref2.index,
    style = _ref2.style,
    childrenCount = _ref2.childrenCount,
    props = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  if (_reactNative.Platform.OS === 'web') {
    return (0, _jsxRuntime.jsx)("div", Object.assign({
      "aria-roledescription": "item",
      "aria-label": "".concat(index + 1, " of ").concat(childrenCount),
      style: _reactNative.StyleSheet.flatten(style)
    }, props, {
      children: children
    }));
  }
  return (0, _jsxRuntime.jsx)(_reactNative.View, Object.assign({
    style: style
  }, props, {
    children: children
  }));
});
var Carousel = exports.Carousel = (0, _react.memo)(function (_ref3) {
  var containerStyle = _ref3.containerStyle,
    title = _ref3.title,
    description = _ref3.description,
    linkLabel = _ref3.linkLabel,
    linkUrl = _ref3.linkUrl,
    children = _ref3.children,
    isOverflowVisible = _ref3.isOverflowVisible,
    maxItemWidth = _ref3.maxItemWidth,
    Image = _ref3.Image,
    _ref3$hasTarget = _ref3.hasTarget,
    hasTarget = _ref3$hasTarget === void 0 ? false : _ref3$hasTarget,
    emptyMessage = _ref3.emptyMessage;
  (0, _useLang.useLang)();
  var _useTranslation = (0, _reactI18next.useTranslation)(),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(children),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    _children = _useState2[0];
  var _childrenCount = _react["default"].Children.count(_children);
  var _useStyles = (0, _styles.useStyles)({
      childrenCount: _childrenCount,
      maxItemWidth: maxItemWidth,
      isOverflowVisible: isOverflowVisible
    }),
    styles = _useStyles.styles,
    spacerWidth = _useStyles.spacerWidth,
    rawMaxItemWidth = _useStyles.rawMaxItemWidth,
    targetSize = _useStyles.targetSize;
  var _STYLES$useStyles2 = _styles2.STYLES.useStyles(),
    bp = _STYLES$useStyles2.bp;
  var _scrollViewContainer = (0, _react.useRef)(null);
  var _scrollView = (0, _react.useRef)(null);
  var _useState3 = (0, _react.useState)(0),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    _contentWidth = _useState4[0],
    _setContentWidth = _useState4[1];
  var _useState5 = (0, _react.useState)(0),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    _page = _useState6[0],
    _setPage = _useState6[1];
  var _offsetX = (0, _react.useRef)(new _reactNative.Animated.Value(0)).current;
  var _webCarouselId = (0, _react.useRef)("Carousel-".concat((0, _utils.GenerateId)()));
  var _webIsMouseDown = (0, _react.useRef)(false);
  var _webStartX = (0, _react.useRef)(0);
  var _webScrollLeft = (0, _react.useRef)(0);
  var _hasTitle = !!title;
  var _hasDescription = !!description;
  var _hasLink = !!linkLabel && !!linkUrl;
  var _hasChildren = _childrenCount > 0;
  var _hideImage = !isOverflowVisible || !bp.desktop;
  var _hasImage = !!Image && !_hideImage;
  var _hasEmptyMessage = !!emptyMessage && !_hasChildren;
  var _itemWidth = (0, _react.useMemo)(function () {
    return Math.min(rawMaxItemWidth, (_contentWidth - spacerWidth * 2) / _childrenCount);
  }, [_childrenCount, _contentWidth, rawMaxItemWidth, spacerWidth]);
  var _isScrolling = (0, _react.useRef)();
  var _handlePaging = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(index) {
      var _scrollView$current;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _scrollView == null ? void 0 : (_scrollView$current = _scrollView.current) == null ? void 0 : _scrollView$current.scrollTo({
              x: _itemWidth * index,
              animated: true
            });
            window.clearTimeout(_isScrolling.current);
            _isScrolling.current = setTimeout(function () {
              _setPage(index);
            }, 50);
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function _handlePaging(_x2) {
      return _ref4.apply(this, arguments);
    };
  }();
  var _handleScroll = function _handleScroll(event) {
    if (!event) return;
    var _item = 0;
    if (event.nativeEvent.contentOffset.x > 0) {
      _item = Math.round(event.nativeEvent.contentOffset.x / _itemWidth);
      window.clearTimeout(_isScrolling.current);
      _isScrolling.current = setTimeout(function () {
        _setPage(_item);
      }, 50);
    }
  };
  var _webStartDrag = function _webStartDrag(e) {
    var _scrollViewElement = _scrollView.current;
    _webIsMouseDown.current = true;
    _webStartX.current = e.pageX - _scrollViewElement.offsetLeft;
    _webScrollLeft.current = _scrollViewElement.scrollLeft;
  };
  var _webDragging = function _webDragging(e) {
    e.preventDefault();
    if (!_webIsMouseDown.current) return;
    var _scrollViewElement = _scrollView.current;
    var _x = e.pageX - _scrollViewElement.offsetLeft;
    var _scroll = _x - _webStartX.current;
    _scrollViewElement.scrollLeft = _webScrollLeft.current - _scroll;
  };
  var _webStopDrag = function _webStopDrag() {
    _webIsMouseDown.current = false;
  };
  (0, _react.useEffect)(function () {
    var _scrollViewContainerElement = _scrollViewContainer.current;
    var _scrollViewElement = _scrollView.current;
    if (_reactNative.Platform.OS === 'web') {
      var _window, _window$document;
      if (_scrollViewContainerElement) {
        _scrollViewContainerElement == null ? void 0 : _scrollViewContainerElement.setAttribute == null ? void 0 : _scrollViewContainerElement.setAttribute('aria-roledescription', 'carousel');
      }
      if (_scrollViewElement) {
        _scrollViewElement == null ? void 0 : _scrollViewElement.setAttribute == null ? void 0 : _scrollViewElement.setAttribute('role', 'group');
        _scrollViewElement == null ? void 0 : _scrollViewElement.setAttribute == null ? void 0 : _scrollViewElement.setAttribute('aria-live', 'polite');
        title && (_scrollViewElement == null ? void 0 : _scrollViewElement.setAttribute == null ? void 0 : _scrollViewElement.setAttribute('label', title));
        _scrollViewElement == null ? void 0 : _scrollViewElement.addEventListener == null ? void 0 : _scrollViewElement.addEventListener('mousedown', _webStartDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.addEventListener == null ? void 0 : _scrollViewElement.addEventListener('mouseup', _webStopDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.addEventListener == null ? void 0 : _scrollViewElement.addEventListener('mouseleave', _webStopDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.addEventListener == null ? void 0 : _scrollViewElement.addEventListener('mousemove', _webDragging);
      }
      if ((_window = window) != null && (_window$document = _window.document) != null && _window$document.createElement) {
        var _style = window.document.createElement('style');
        _style.innerHTML = "[id=\"".concat(_webCarouselId.current, "\"] > div > div { scroll-snap-align: center ;}");
        document.head.append(_style);
      }
    }
    return function () {
      if (_scrollViewElement && _reactNative.Platform.OS === 'web') {
        _scrollViewElement == null ? void 0 : _scrollViewElement.removeEventListener == null ? void 0 : _scrollViewElement.removeEventListener('mousedown', _webStartDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.removeEventListener == null ? void 0 : _scrollViewElement.removeEventListener('mouseup', _webStopDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.removeEventListener == null ? void 0 : _scrollViewElement.removeEventListener('mouseleave', _webStopDrag);
        _scrollViewElement == null ? void 0 : _scrollViewElement.removeEventListener == null ? void 0 : _scrollViewElement.removeEventListener('mousemove', _webDragging);
      }
    };
  }, [title]);
  (0, _react.useEffect)(function () {
    return function () {
      window.clearTimeout(_isScrolling.current);
    };
  }, []);
  return (0, _jsxRuntime.jsxs)(_reactNative.View, {
    style: [styles.container, containerStyle],
    testID: "Carousel",
    children: [_hasTitle && (0, _jsxRuntime.jsx)(_Heading.Heading, {
      level: 2,
      style: styles.title,
      children: title
    }), _hasDescription && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.description,
      children: description
    }), _hasEmptyMessage && (0, _jsxRuntime.jsx)(_reactNative.Text, {
      style: styles.emptyMessage,
      children: emptyMessage
    }), _hasChildren && (0, _jsxRuntime.jsxs)(_reactNative.View, {
      style: styles.carousel,
      testID: "CarouselItems",
      ref: _scrollViewContainer,
      children: [(0, _jsxRuntime.jsxs)(_reactNative.View, {
        children: [_hasImage && (0, _jsxRuntime.jsx)(ImageContainer, {
          styles: styles,
          offsetX: _offsetX,
          spacerWidth: spacerWidth,
          children: hasTarget ? (0, _jsxRuntime.jsx)(_reactNative.View, {
            style: styles.target,
            testID: "CarouselImageTarget",
            children: (0, _jsxRuntime.jsx)(Image, {
              size: targetSize
            })
          }) : (0, _jsxRuntime.jsx)(Image, {})
        }), (0, _jsxRuntime.jsxs)(_reactNative.Animated.ScrollView, {
          nativeID: _webCarouselId.current,
          ref: _scrollView,
          onContentSizeChange: _setContentWidth,
          horizontal: true,
          decelerationRate: 'fast',
          disableIntervalMomentum: true,
          showsHorizontalScrollIndicator: false,
          onScroll: _reactNative.Animated.event([{
            nativeEvent: {
              contentOffset: {
                x: _offsetX
              }
            }
          }], {
            useNativeDriver: _utils.useNativeDriver,
            listener: _handleScroll
          }),
          scrollEventThrottle: 16,
          contentContainerStyle: styles.scrollContainer,
          pagingEnabled: true,
          style: styles.scrollview,
          snapToOffsets: _react["default"].Children.map(_children, function (_, index) {
            return index * _itemWidth;
          }),
          children: [(0, _jsxRuntime.jsx)(_reactNative.View, {
            style: {
              width: spacerWidth
            }
          }), _react["default"].Children.map(_children, function (child, index) {
            if (!child) return null;
            return (0, _jsxRuntime.jsx)(SlideChild, {
              childrenCount: _childrenCount,
              index: index,
              style: styles.carouselItem,
              children: child
            }, "".concat(child.key, "-item"));
          }), (0, _jsxRuntime.jsx)(_reactNative.View, {
            style: {
              width: spacerWidth
            }
          })]
        })]
      }), _childrenCount > 1 && (0, _jsxRuntime.jsx)(_Pagination.Pagination, {
        currentItem: _page,
        totalItems: _childrenCount,
        label: t("carousel:item"),
        onPress: _handlePaging
      })]
    }), _hasLink && (0, _jsxRuntime.jsx)(_Button.Button, {
      label: linkLabel,
      href: linkUrl,
      type: _Button.ButtonType.brand,
      containerStyle: styles.link
    })]
  });
});